import isIOS from '@utils/isIOS';
const prepareUrlToShare = (url: string) => {
  try {
    return new URL(url).toString();
  } catch (error) {
    console.warn('URL parsing failed:', error);
    if (isIOS()) {
      return url;
    }
  }
  return url;
};
export default prepareUrlToShare;